module.exports = __webpack_public_path__ + "static/media/aircraft-army-fighter-svgrepo-com.c5a7d693.svg";